<div #statusFlag></div><span class="cmx-flag-status__label">{{ label }}</span>
